import React, { useState, useEffect, useRef, useCallback } from "react";
import MetaData from "../helpers/MetaData";
import ApiService from "../api/ApiService";
import PageHeader from "../components/common/PageHeader";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/youtube.scss";
import GoToTop from "../helpers/GoToTop";
import { useParams } from "react-router-dom";
import HeaderSection from "../components/common/HeaderSectin";
import YouTubeSection from "../components/socialmedia/YouTubeSection";
import InstagramSection from "../components/socialmedia/InstagramSection";

const SocialMedia = () => {
  const { id } = useParams();
  const [meta, setMeta] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [top, setTop] = useState(0);

  useEffect(() => {
    const fetchMetaData = async () => {
      try {
        setLoading(true);
        const metaRes = await ApiService.fetchMetaData("The Story Of Attapur");
        setMeta(metaRes);
      } catch (error) {
        console.error("❌ Error fetching meta data:", error);
        setError("Failed to load page data");
      } finally {
        setLoading(false);
      }
    };

    fetchMetaData();
  }, []);

  const festRef = useCallback((node) => {
    if (node) {
      setTop(id === "instagram" ? node.offsetTop + 300 : node.offsetTop - 2070);
    }
  }, [id]);

  if (loading) {
    return (
      <>
        <MetaData title="Social Media - ISKCON of Attapur" />
        <PageHeader title="Social Media" imgSrc="/images/page-header/20.webp" />
         <HeaderSection  title="Social Media - ISKCON BHIWANDI" desc="Stay connected with ISKCON Attapur on social media for the latest updates on spiritual events, festivals, kirtans, and discourses. 
      Follow us for daily inspiration, Bhagavad-gita wisdom, and glimpses of devotional activities at our temple" />
        <section className="yt-links-sec">
          <div className="container mt-5 text-center">
            <div className="spinner-border text-dark" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-3">Loading social media content...</p>
          </div>
        </section>
      </>
    );
  }

  if (error) {
    return (
      <>
        <MetaData title="Social Media - ISKCON of Attapur" />
        <HeaderSection />
        <section className="bg-white">
          <div className="container mt-5 text-center">
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
            <button 
              className="btn btn-warning text-white"
              onClick={() => window.location.reload()}
            >
              Retry
            </button>
          </div>
        </section>
      </>
    );
  }

  return (
    <>
      <MetaData title="Social Media - ISKCON of Attapur" />
       <HeaderSection  title="Social Media - ISKCON ATTAPUR" desc="Stay connected with ISKCON Attapur on social media for the latest updates on spiritual events, festivals, kirtans, and discourses. 
      Follow us for daily inspiration, Bhagavad-gita wisdom, and glimpses of devotional activities at our temple" />

      <section className="bg-white">
        <YouTubeSection />
        
        <div className="inst-border-div"></div>
        
        <div className="mt-5" ref={festRef}>
          <InstagramSection />
        </div>
      </section>
      
      <GoToTop top={top} />
    </>
  );
};

export default SocialMedia;